require('./angular-cookies');
module.exports = 'ngCookies';



//////////////////
// WEBPACK FOOTER
// ./~/angular-cookies/index.js
// module id = 5
// module chunks = 0 2